import React, { useState } from 'react';
import axios from 'axios';
import { Atom } from 'react-loading-indicators';

const CATEGORIES = [
  'Success story',
  'M&A playbook',
  'Recent acquisition news',
  'Recent groundbreaking news',
  'Recent speculations about M&A deals',
  'Market Reports and Trends',
];

const CATEGORY_DESCRIPTION_PROMPTS = {
  "Success story": "Who should this post be about? Briefly describe the person or company.",
  "M&A playbook": "What is the M&A playbook about? Briefly describe what it should cover.",
  "Recent acquisition news": "Got a specific news story in mind? Enter it here - otherwise we'll handle it",
  "Recent groundbreaking news": "Got a specific news story in mind? Enter it here - otherwise we'll handle it",
  "Recent speculations about M&A deals": "Got a specific news story in mind? Enter it here - otherwise we'll handle it",
  "Market Reports and Trends": "Got a specific report or trend in mind? Enter it here - otherwise we'll handle it",
};

function GenerateLinkedInPost() {
  const [category, setCategory] = useState(CATEGORIES[0]);
  const [description, setDescription] = useState('');
  const [recipientEmail, setRecipientEmail] = useState('gaj.tanwar@feinternational.com');
  const [isLoading, setIsLoading] = useState(false);

  const styles = {
    pageContainer: {
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      paddingTop: '10vh',
    },
    appContainer: () => ({
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
      maxWidth: '100%',
      padding: '10px',
    }),
    formContainer: () => ({
      width: '100%',
      maxWidth: '400px',
      transition: 'all 0.5s ease',
      padding: '20px',
    }),
    form: {
      display: 'flex',
      flexDirection: 'column',
    },
    headerText: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      marginTop: '10px',
      marginBottom: '20px',
      borderBottom: '1px solid black',
    },
    input: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
    },
    select: {
      margin: '5px 0',
      padding: '7px',
      borderRadius: '4px',
      border: '1px solid #cccccc',
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      backgroundColor: 'white',
    },
    label: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '12px',
      marginTop: '10px',
      marginBottom: '2px',
      fontWeight: 'bold',
    },
    button: {
      margin: '10px 0',
      padding: '10px',
      backgroundColor: '#6487dc',
      color: 'white',
      border: 'none',
      cursor: 'pointer',
      borderRadius: '4px',
    },
    dynamicPrompt: {
      fontFamily: 'Arial, sans-serif',
      fontSize: '11px',
      color: '#555',
      marginTop: '2px',
      marginBottom: '6px',
      fontStyle: 'italic',
    },
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      category,
      description,
      recipientEmail,
    };

    axios
      .post('/api/generate_linkedin_post', payload, {
        headers: { 'Content-Type': 'application/json' },
      })
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          alert('LinkedIn post generated. Please check your email.');
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error('Error generating LinkedIn post:', error);
        alert('Error generating LinkedIn post. Please try again.');
      });
  };

  return (
    <div style={styles.appContainer()}>
      <div style={styles.formContainer()}>
        <form onSubmit={handleSubmit} style={styles.form}>
          <h3 style={styles.headerText}>Generate LinkedIn Post</h3>

          <label style={styles.label}>Category</label>
          <select
            value={category}
            onChange={(e) => setCategory(e.target.value)}
            style={styles.select}
            required
          >
            {CATEGORIES.map((cat) => (
              <option key={cat} value={cat}>
                {cat}
              </option>
            ))}
          </select>

          <label style={styles.label}>Description</label>
          <textarea
            placeholder={CATEGORY_DESCRIPTION_PROMPTS[category]}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ ...styles.input, resize: 'vertical', minHeight: '100px' }}
          />

          <label style={styles.label}>Recipient Email</label>
          <select
            value={recipientEmail}
            onChange={(e) => setRecipientEmail(e.target.value)}
            style={styles.select}
            required
          >
            <option value="thomas@feinternational.com">thomas@feinternational.com</option>
            <option value="ray.deleon@feinternational.com">ray.deleon@feinternational.com</option>
            <option value="gaj.tanwar@feinternational.com">gaj.tanwar@feinternational.com</option>
            <option value="sumedh.kadam@feinternational.com">sumedh.kadam@feinternational.com</option>
          </select>

          {isLoading && (
            <div align="center" style={{ marginTop: '20px' }}>
              <Atom color="#32cd32" size="medium" text="Generating LinkedIn post..." />
            </div>
          )}

          <button type="submit" disabled={isLoading} style={styles.button}>
            Generate LinkedIn Post
          </button>
        </form>
      </div>
    </div>
  );
}

export default GenerateLinkedInPost;
